import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Pennsylvania() {
  const cityName = "Pennsylvania";
  const state = "PA";
  const fullCityName = `${cityName}, ${state}`;
  const areaName = "Pennsylvania State";
  
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog13.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Luxury Transportation Services in {fullCityName}
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>/</span>
            <a href="/cities" className="hover:text-logo-green">Areas We Serve</a>
            <span>/</span>
            <span className="text-logo-green">{fullCityName}</span>
          </div>
        </div>
      </div>
    </section>

    {/* Main Content Section */}
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[65%_35%] gap-8 sm:gap-12">
          {/* Left Side - Main Content */}
          <div>
            <h1 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              Limousine Service & Party Bus Rentals in {fullCityName}
            </h1>
            <p className="text-gray-600 mb-3 sm:mb-3">
              Serving all of {cityName} and the {areaName} area
            </p>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              If you are looking for a superior {areaName} Limo Service in {fullCityName}, all of us at Majestic Voyage USA can easily offer you professional limousine services that are unparalleled. For the past two decades, we have been proudly helping individuals and corporations with all of their transportation needs all throughout <strong>New York, New Jersey, Connecticut, Pennsylvania, and Washington D.C.</strong>. We've got the knowledge, dedication to high quality, and fleet necessary to help make your upcoming trip a hassle-free experience.
            </p>
            <h2 className="font-bold text-gray-900 mb-3 sm:mb-4 leading-tight">
              {cityName} Limousine Service and Party Bus Rentals You Can Trust In
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              When it comes to limousine service, {fullCityName} residents deserve the best. Our full array of professional limousine services comprises of luxury transportation solutions for both business or pleasure. Manned by an elite team of elite chauffeurs and trusted in {cityName} for over 20 years, we cater to corporate functions, outings, group travel, and special event limo services throughout {fullCityName}. Irrespective of your needs, big or small, our company is ready to take you where you need to go.
            </p>
          </div>

          {/* Right Side - Why Choose Us */}
          <div>
            <h2 className="text-xl sm:text-2xl lg:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
              Why Choose Majestic Voyage USA?
            </h2>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">DIVERSE FLEET OF NEW LUXURY LIMOUSINES & PARTY BUSES</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">WORLD CLASS CUSTOMER CARE</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">RELIABLE, PROFESSIONAL CHAUFFEURS</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">AWARD WINNING SERVICE</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">COMPLIMENTARY ON-BOARD BEVERAGES</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">FULLY INSURED AND PROPERLY LICENSED</span>
              </li>
              <li className="flex items-start hover:bg-gray-50 p-3 rounded-lg transition-all duration-300 cursor-pointer hover:translate-x-2">
                <span className="text-logo-green mr-3 mt-1 text-xl transition-colors duration-300">✓</span>
                <span className="text-base  text-gray-900 font-semibold">TRUSTED & RECOMMENDED FOR OVER 20 YEARS</span>
              </li>
            </ul>
            <div className="mt-6 sm:mt-8 flex flex-col sm:flex-row gap-4">
              <a href="/booknow" className="bg-blue-600 text-white px-6 sm:px-8 py-3 font-semibold hover:bg-blue-700 transition-colors text-center">
                GET A QUOTE
              </a>
              <a href="tel:+17182004140" className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center">
                CALL US NOW
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Trust Section */}
    <section className="bg-white  px-4 sm:px-6 mb-4 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-[70%_30%] gap-8 sm:gap-12">
          {/* Left Side - Text Content */}
          <div>
            <h2 className="font-bold text-gray-900 mb-4 sm:mb-6">
              {cityName} Limousine Service and Party Bus Rentals You Can Trust In
            </h2>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              When it comes to limousine service, {fullCityName} residents deserve the best. Our full array of professional limousine services comprises of luxury transportation solutions for both business or pleasure. Manned by an elite team of elite chauffeurs and trusted in {cityName} for over 20 years, we cater to corporate functions, outings, group travel, and special event limo services throughout {fullCityName}. Irrespective of your needs, big or small, our company is ready to take you where you need to go.
            </p>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed font-semibold">
              We provide the following professional service:
            </p>
            <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
              <li className="text-gray-900">• Luxury wedding day transportation for the entire bridal party and shuttle service</li>
              <li className="text-gray-900">• Birthday party packages that are perfect whether your turning 1 or 100</li>
              <li className="text-gray-900">• Planning a bachelor party or bachelorette party? Let us help you plan the ultimate last night out</li>
              <li className="text-gray-900">• School functions and senior proms are right around the corner. Book your limo or party bus early</li>
              <li className="text-gray-900">• Transportation for all sporting events in New York and New Jersey</li>
            </ul>
            <p className="text-gray-900 mb-4 sm:mb-6 leading-relaxed">
              Our expertly trained transportation professionals have years of experience in getting our client and their guests to the destinations safely, on time and in style. Headquartered in New York, we are the leading limousine and party bus rental company in {fullCityName}. And we service the entire <strong>New York, New Jersey, Connecticut, Pennsylvania, Washington D.C.</strong> region and neighboring places.
            </p>
          </div>

          {/* Right Side - Map */}
          <div>
            <div className="w-full h-[400px] sm:h-[500px] bg-gray-200 rounded-lg overflow-hidden">
              <iframe
                src={`https://www.google.com/maps?q=${encodeURIComponent(cityName)}+${state}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`${cityName} Location Map`}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>

    


    {/* Fleet Selection Section - Dark Background */}
    <section className="bg-gray-900 py-16 sm:py-20 px-4 sm:px-6 lg:px-10 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img 
          src="blog12.png" 
          alt="Fleet Background" 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="relative z-10 max-w-[1200px] mx-auto text-center">
        <h2 className="font-bold text-white mb-4 sm:mb-6">
          The Largest Selection of Party Buses, SUV Limousines and Limos in {fullCityName}
        </h2>
        <p className="text-white mb-6 sm:mb-8 max-w-3xl mx-auto">
          Our limousine company offers the largest, most diverse fleet of new model luxury limousines, SUV limos, exotic sedans, limo buses and limo coach party bus rentals in {fullCityName}.
        </p>
        <a 
          href="/fleet" 
          className="inline-block bg-white text-black border-2 border-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors rounded-lg"
        >
          CHOOSE YOUR RIDE
        </a>
      </div>
    </section>

    

    {/* What Makes Us Different Section */}
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-bold text-gray-900 mb-4 sm:mb-6">
          What Makes Majestic Voyage USA Different For Our Competitors?
        </h2>
        <p className="text-base sm:text-lg text-gray-900 mb-4 sm:mb-6 leading-relaxed">
          We are a <strong>high quality limo service</strong> in {fullCityName}. You, the client, are why we are in business, and it is for this reason that we use your satisfaction as a way to measure our goals. Satisfying customers is the thing that we strive for. Our objective is for you to be happy every step of the way; after all, you are trusting us to get you and your party to your destination safely. We value your trust. It's our goal to make your trip as comfortable, easy, and stress-free as possible.
        </p>
        <p className="text-base sm:text-lg text-gray-900 mb-4 sm:mb-6 leading-relaxed">
          We are a family-run business and we have over twenty years of experience in luxury ground transportation. We are a leader in our industry and we are proud of our <strong>personal and friendly</strong> service. Our excellent reputation matters most to all of us, and that is why we're so focused on making your trip with us as smooth as possible. We make sure that every request is met in a timely manner, and that you are treated like a VIP from start to finish.
        </p>
      </div>
    </section>

    <FAQ/>
    <Footer/>
    </>
  );
}

export default Pennsylvania;
